var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg017CloudStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4999 18C20.8062 17.9871 22.7294 16.2328 22.9535 13.9374C23.1776 11.642 21.6301 9.54877 19.3699 9.09C18.6823 5.56076 15.5955 3.01005 11.9999 3C9.16232 2.98834 6.56447 4.5897 5.29994 7.13C2.62176 7.66498 0.741819 10.0841 0.884835 12.8115C1.02785 15.5388 3.1505 17.7481 5.86994 18C6.07966 18.0152 6.29021 18.0152 6.49994 18H10.9999V20H2.99994C2.44765 20 1.99994 20.4477 1.99994 21C1.99994 21.5523 2.44765 22 2.99994 22H20.9999C21.5522 22 21.9999 21.5523 21.9999 21C21.9999 20.4477 21.5522 20 20.9999 20H12.9999V18H18.4999ZM6.49994 16H6.10994C4.17694 16 2.60994 14.433 2.60994 12.5C2.60994 10.567 4.17694 9 6.10994 9C6.47438 8.96225 6.78899 8.7282 6.92994 8.39C7.89049 6.02901 10.3497 4.63968 12.8677 5.0355C15.3857 5.43132 17.3001 7.50817 17.4899 10.05C17.5268 10.5748 17.9639 10.9813 18.4899 10.98C19.8706 10.98 20.9899 12.0993 20.9899 13.48C20.9899 14.8607 19.8706 15.98 18.4899 15.98L6.49994 16Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg017CloudStorage);
export default __webpack_public_path__ + "static/media/017-cloud-storage.71b5f71dfd76201ec4f6f48fad08194e.svg";
export { ForwardRef as ReactComponent };